import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import { Button, Popup } from 'next-common-lib';
import i18n from 'i18n';
import { isIE } from 'utils/common';
import useWindowDimensions from 'utils/hook/useWindowDimension';
import { ALERT_CONFIRM_MODAL_SIZE } from 'constants/IncorporationConstants';
import * as confirmActions from 'redux/ducks/common/confirmDucks';

export const Confirm = () => {
  const dispatch = useDispatch();
  const confirm = useSelector(state => state.confirm);
  const scrollY = window.scrollY;

  const mappingMessage = () => {
    const result = [];
    confirm.message.forEach(msg => {
      result.push(<Trans i18nKey={i18n.t(msg)} />);
    });
    return result;
  };
  const windowDimension = useWindowDimensions();

  const setTopPosition = () => {
    return windowDimension.resizeHeight / 2 - ALERT_CONFIRM_MODAL_SIZE.xs.height / 2 + scrollY;
  };

  const setLeftPosition = () => {
    return windowDimension.resizeWidth / 2 - ALERT_CONFIRM_MODAL_SIZE.xs.width / 2;
  };

  return (
    <>
      {confirm.isShow && (
        <Popup
          id="employee_Confirm"
          top={`${setTopPosition()}px`}
          left={`${setLeftPosition()}px`}
          isShow={confirm.isShow}
          isDimed={isIE() && confirm.isShow ? false : confirm.isShow}
          dimedClassName={isIE() ? 'transparent' : 'has-bg'}
          size="xs"
          componentType="normalPopup"
          closeFunction={() => {
            dispatch(confirmActions.close());
          }}
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {confirm.title ? i18n.t(confirm.title) : i18n.t('EM_T_NOTICE')}
            </h1>,
          ]}
          contentsComponent={mappingMessage()}
          bottomComponent={[
            <div className="btn-set al-right">
              <div className="btn-group">
                <Button
                  componentType="solid"
                  className="secondary"
                  size="md"
                  label={i18n.t('EM_T_CANCEL')}
                  onClick={() => {
                    window.scrollTo(0, scrollY);
                    dispatch(confirmActions.close());
                  }}
                />
                <Button
                  componentType="solid"
                  className="primary"
                  size="md"
                  label={i18n.t('EM_T_OK')}
                  onClick={() => {
                    confirm.callback();
                    window.scrollTo(0, scrollY);
                    dispatch(confirmActions.close());
                  }}
                />
              </div>
            </div>,
          ]}
        />
      )}
    </>
  );
};
Confirm.propTypes = {};
Confirm.defaultProps = {};
export default Confirm;
